import Collection from './Hydra/Collection';
import {addAuthHeader} from "./Helper";
import {SessionManager} from '../session-manager';


export function getHeaders(isPublic= false, headers = []) {
    const HEADERS = new Headers();
    HEADERS.append('Accept', 'application/ld+json');
    HEADERS.append('Content-Type', 'application/ld+json');

    if (!isPublic && SessionManager.isAuthenticated()) {
        addAuthHeader(HEADERS);
    }

    if (SessionManager.getAppSlug()) {
        HEADERS.append('X-App-Slug', SessionManager.getAppSlug());
    }

    headers.map((header) => {
        HEADERS.append(header.name, header.value);
    });

    return HEADERS;
}

export const API_URL = import.meta.env.VITE_BASE_URL || '';
const cache = new Map();

/**
 *
 * @param url
 * @param init
 * @param asCollection
 * @param useCache
 * @param isPublic
 * @return {Promise}
 */
export function getPromise(url, init, asCollection = false, useCache = false, isPublic = false) {
    if (useCache && cache.has(url)) {
        return Promise.resolve(cache.get(url));
    }

    return new Promise((resolve, reject) => {
        if (SessionManager.isExpired() && ! isPublic) {
            return reject('Session expired');
        }

        fetch(url, init).then(res => res.json().then(data => {
            if (!res.ok) {
                if (403 === res.status) {
                    SessionManager.setExpired(true);
                }

                return reject(data);
            }

            cache.set(url, asCollection ? new Collection(data) : data);
            resolve(cache.get(url));
        })).catch(reject);
    });
}


export function getPromiseWithoutContent(url, init) {
    if (cache.has(url)) {
        return Promise.resolve(cache.get(url));
    }

    return new Promise((resolve, reject) => {
        fetch(url, init).then(res => {
            if (!res.ok) {
                if (403 === res.status) {
                    SessionManager.setExpired(true);
                }

                return reject(res);
            }

            resolve(res);

        }).catch(reject);
    });
}


export class ModelManager {

    /**
     * Constructor
     */
    constructor() {

    }


    /**
     *
     * @param modelName
     * @param filters
     * @param isPublic
     * @return {Promise}
     */
    static fetchList(modelName, filters = {}, isPublic = false, config = {}) {
        let query = '';

        if (Object.keys(filters).length) {
            const search = new URLSearchParams();

            for (const key in filters) {
                search.append(key, filters[key]);
            }

            query = `?${search.toString()}`;
        }

        config = Object.assign({
            method: 'GET',
            headers: getHeaders(isPublic),
        }, config);

        const url = `${API_URL}${modelName.toLowerCase()}${query}`;

        return getPromise(url, config, true, false, isPublic);
    }


    /**
     *
     * @param modelName
     * @param id
     * @param isPublic
     * @return {Promise}
     */
    static fetch(modelName, id = null, isPublic = false) {
        let url = `${API_URL}${modelName.toLowerCase()}`;
        if (id) {
            url = url + '/'+id;
        }

        return getPromise(url, {headers: getHeaders(isPublic)}, false, false, isPublic);
    }


    /**
     * Delete model.
     *
     * @param {string} modelName
     * @param {int} id
     * @returns {Promise}
     */
    static delete(modelName, id) {
        const url = `${API_URL}${modelName.toLowerCase()}/${id}`;

        // Clear cache
        cache.forEach(function (value, key) {
            if (key.indexOf(`${API_URL}${modelName.toLowerCase()}`) !== -1) {
                cache.delete(key);
            }
        });

        return getPromiseWithoutContent(url, {method: 'DELETE', headers: getHeaders(isPublic)});
    }


    /**
     * @param model
     * @param isPublic
     *
     * @returns {Promise}
     */
    static save(model, isPublic = false) {

        if (!model['@id']) {
            throw new Error('Id missing');
        }

        const url = `${API_URL}${model['@id']}`;
        const data = {...model};

        for (const prop of ['@id', 'id']) {
            if (data.hasOwnProperty(prop)) {
                delete data[prop];
            }
        }

        const opts = {
            headers: getHeaders(isPublic),
            method: model.id ? 'PUT' : 'POST',
            body: JSON.stringify(data),
        };

        // Clear cache
        cache.forEach(function (value, key) {
            if (key.indexOf(url) !== -1) {
                cache.delete(key);
            }
        });


        return getPromise(url, opts);
    }
}